module.exports = __webpack_public_path__ + "img/hhdz.920f21ca.jpg";